import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { Button } from '@newComponents/Button/Button'
import { PresentationItem } from '@newComponents/Presentation/PresentationItem'

import { UserPresentationsScreenOtherPresentationsSection_user$key } from './__generated__/UserPresentationsScreenOtherPresentationsSection_user.graphql'

export const UserPresentationsScreenOtherPresentationsSection = ({
  user,
}: {
  user: UserPresentationsScreenOtherPresentationsSection_user$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment UserPresentationsScreenOtherPresentationsSection_user on User
      @refetchable(
        queryName: "UserPresentationsScreenOtherPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        otherPresentations: presentations(
          first: $count
          after: $cursor
          timeSelection: OTHER
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "UserPresentationsScreenOtherPresentationsSection_user_otherPresentations"
          ) {
          edges {
            node {
              ...PresentationItemNew_presentation
            }

            cursor
          }
        }
      }
    `,
    user
  )

  if (data.otherPresentations.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$grey8'>Other Presentations</Strong>
        <Separator borderColor='$grey4' />
      </XStack>

      {data.otherPresentations.edges.map((edge) => {
        return (
          <PresentationItem
            key={edge.cursor}
            presentation={edge.node}
            numberOfLines={8}
          />
        )
      })}

      {hasNext && (
        <Button
          secondary
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Button.Text secondary>
            {isLoadingNext ? 'Loading...' : 'More'}
          </Button.Text>
        </Button>
      )}
    </YStack>
  )
}
